import { useEffect } from 'react';

/**
 * Hält das Display während zeitkritischer Phasen wach (GDD Mobile-Härtung).
 * Ohne das sperrt sich das Handy mitten in der Diskussion — die häufigste
 * praktische Störung am Tisch. Degradiert still, wo die API fehlt.
 */
export function useWakeLock(active: boolean): void {
  useEffect(() => {
    if (!active || typeof navigator === 'undefined' || !('wakeLock' in navigator)) return;

    let sentinel: WakeLockSentinel | null = null;
    let cancelled = false;

    const request = async () => {
      try {
        const lock = await (navigator as Navigator & { wakeLock: WakeLock }).wakeLock.request(
          'screen',
        );
        if (cancelled) {
          void lock.release();
          return;
        }
        sentinel = lock;
      } catch {
        // Manche Browser lehnen die Anfrage ab (z. B. wenig Akku) — kein Fehlerfall.
      }
    };

    const onVisibilityChange = () => {
      if (document.visibilityState === 'visible' && !sentinel) void request();
    };

    void request();
    document.addEventListener('visibilitychange', onVisibilityChange);

    return () => {
      cancelled = true;
      document.removeEventListener('visibilitychange', onVisibilityChange);
      void sentinel?.release();
    };
  }, [active]);
}

interface WakeLock {
  request(type: 'screen'): Promise<WakeLockSentinel>;
}

interface WakeLockSentinel {
  release(): Promise<void>;
}
